const template = require('./index.html')
const { stringToBoolean } = require('@isoftdata/utility-string')
const { booleanToString } = require('@isoftdata/utility-boolean')
const { v4: uuid } = require('@lukeed/uuid')

const defaultOptions = { twoway: true }

const isBool = input => typeof (input) === 'boolean'

module.exports = function makeCheckboxComponent({ twoway = true } = defaultOptions) {
	return Ractive.extend({
		twoway,
		template,
		attributes: {
			required: [],
			optional: [ 'id', 'label', 'showLabel', 'checked', 'title', 'indeterminate', 'radioButtons', 'inline', 'name', 'trueLabel', 'falseLabel' ],
		},
		data() {
			return {
				id: `id${uuid()}`,
				label: '',
				name: '',
				showLabel: true,
				checked: 'False',
				title: '',
				radioButtons: false,
				indeterminate: false,
				inline: false,
				twoway,
				trueLabel: 'Yes',
				falseLabel: 'No',
			}
		},
		computed: {
			//The user could bind a string boolean or a native javascript boolean.
			//Make sure both are supported.
			//isChecked needs to always be a boolean type
			isChecked: {
				get() {
					const checked = this.get('checked')
					return isBool(checked) ? checked : stringToBoolean(checked)
				},
				set(isChecked) {
					this.set({ checked: isBool(this.get('checked')) ? isChecked : booleanToString(isChecked) })
				},
			},
		},
		onrender() {
			this.observe('indeterminate', v => {
				this.find(`#${this.get('id')}`).indeterminate = !!v
			})
		},
	})
}
